
import { CardBody, CardFooter, CardTitle } from "reactstrap";
import { LectureDtoWithOriginals } from "../../domain/LectureDtoWithOriginals";
import classes from '../lecture.module.scss';
import coursePartService from "../../CoursePartService";
import { Link, useNavigate } from "react-router-dom";

import LnIcon from "src/components/LnIcon";
import { useI18n } from "src/utils/lni18n";
import { FormatTimeDuration } from "src/utils/DateTimeFormat";
import { LectureEntityStatus } from "src/coursepart/domain/LectureEntityStatus";
import CardLink from "src/components/CardLink/CardLink";


const LectureDiffLink = (props: { onContextMenu: React.MouseEventHandler<HTMLElement>, partId: string, lecture: LectureDtoWithOriginals }) => {

    const { languageService: t } = useI18n();
    const { lecture: l, partId, onContextMenu } = props;
    const navigate = useNavigate();


    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if( e.ctrlKey) return;
        coursePartService.selectDiffLecture(partId, l);
    }

    const handleContextMenu = (e: React.MouseEvent<HTMLDivElement>) => {
        coursePartService.selectDiffLecture(partId, l);
        onContextMenu(e);

    }

    const handleDoubleClick = () => {
        coursePartService.selectDiffLecture(partId, l);
        navigate(l.Id)
    }

    const getStatusColor = (lect: LectureDtoWithOriginals) => {

        switch (lect.Status) {
            case LectureEntityStatus.Committed:
                return "";
                break;
            case LectureEntityStatus.Deleted:
                return classes.deletedLect;
                break;

            case LectureEntityStatus.Changed:
                return classes.changedLect;
                break;

            case LectureEntityStatus.New:
                return classes.newLect;
                break;
        }

    }


    return (
        <div onContextMenu={handleContextMenu} onDoubleClick={ handleDoubleClick} onClick={handleClick} key={l.Id} role="listitem"
            className={[(l.Selected ? classes.selectedLecture : ""), getStatusColor(l), classes.card, 'card pointer'].join(' ')} >

                <CardBody className={`p-3 ${classes.cardBody}`}>
                    <CardTitle className={`${classes['card-title']} d-flex`}>
                        <div className={classes.nameDiv}>
                            <CardLink to={l.Id} onKeyboardOpen={() => coursePartService.selectDiffLecture(partId, l)}>{l.Name}</CardLink>
                        </div>
                        <div className="ms-auto ">
                            <div className="d-flex">
                                <div className="m-2 badge text-bg-grey">{(l.Order! + 1)}</div>
                                {l.PrevOrder !=null && <div className="m-2 badge text-bg-warning">{(l.PrevOrder! + 1)}</div>}
                            </div>

                        </div>

                    </CardTitle>
                    <div className={classes['img-wrapper']}>
                        <img className={classes['lecture-img']} src={l.ImageUrl} alt={l.Name} />
                    </div>



                </CardBody>

                <CardFooter className={classes['card-footer']}>
                    <span><LnIcon className={[classes['footer-icon'], 'natural'].join(' ')} name="slides" />
                        &nbsp;{l.NumOfScreens} <span className="d-none d-sm-inline">{t.getText('lecture.screens')}</span></span>
                    {
                        FormatTimeDuration(l.Duration, t) &&
                        <span className="ms-1"><LnIcon className={[classes['footer-icon'], 'natural'].join(' ')} name="time" /> {FormatTimeDuration(l.Duration, t)}</span>
                    }
                </CardFooter>
        </div>
    );

}


export default LectureDiffLink;